import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const XIcon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 48 49"
      fill={'none'}
      {...rest}
    >
      <path
        d="M8 40.5859L21.536 27.0499M26.456 22.1299L40 8.58594M8 8.58594L31.466 40.5859H40L16.534 8.58594H8Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

XIcon.displayName = 'XIcon';
